import { GlowModal, GlowSkeleton } from '@headless-workspace/glow-ds';

export const QuickViewProductMenuSkeleton = () => {
    return (
        <GlowModal.Container fallback={<GlowSkeleton width={'25.5rem'} height={'1.875rem'} />} onClick={undefined}>
            <GlowModal.Content>
                <GlowSkeleton width={'25.5rem'} height={'1.875rem'} />
                <div className={'flex flex-col gap-0.5'}>
                    <GlowSkeleton width={'27.5rem'} height={'1.25rem'} />
                    <GlowSkeleton width={'6.938rem'} height={'1.25rem'} />
                    <GlowSkeleton width={'6.938rem'} height={'1.25rem'} />
                </div>
                <GlowSkeleton width={'27.5rem'} height={'1.25rem'} />
                <div className={'flex flex-col gap-0.5'}>
                    <GlowSkeleton width={'27.5rem'} height={'3.75rem'} />
                    <GlowSkeleton width={'27.5rem'} height={'3.75rem'} />
                    <GlowSkeleton width={'27.5rem'} height={'3.75rem'} />
                    <GlowSkeleton width={'27.5rem'} height={'3.75rem'} />
                    <GlowSkeleton width={'27.5rem'} height={'3.75rem'} />
                    <GlowSkeleton width={'27.5rem'} height={'3.75rem'} />
                </div>
                <GlowSkeleton width={'27.5rem'} height={'7.15rem'} />
            </GlowModal.Content>
            <GlowModal.Footer>
                <GlowSkeleton width={'27.5rem'} height={'3rem'} />
                <GlowSkeleton width={'27.5rem'} height={'3rem'} />
            </GlowModal.Footer>
        </GlowModal.Container>
    );
};
